import React from "react";
import PropTypes from "prop-types";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
import ChatFormInput from "../../shared/ChatFormInput/ChatFormInput";
import SendButton from "../../shared/SendButton/SendButton";
//================ STEP 4 ===============

const HandleFreeQuestion = ({
                                messageValue,
                                addMessage,
                                addBotMessage,
                                inputDisabled,
                                setInputDisable,
                                loadingBotMessage,
                                responseBotDelay,
                                setStep,
                                handleChange,
                                createFreeQuestion
                            }) => {
    const handleFreeQuestion = (e) => {
        loadingBotMessage(true);
        e.preventDefault();
        addMessage(messageValue);
        createFreeQuestion(messageValue);
        setInputDisable(true);
        setTimeout(() => {
            loadingBotMessage(false);
            addBotMessage("Nous avons bien reçu votre question et y répondrons sous 48h, vous serez notifié de notre réponse par email. Merci pour votre confiance et à bientôt !", "botDatepicker");
            setInputDisable(false);
            setStep(5);
        }, responseBotDelay);
    };
    return (
        <ContainerReponse>
            <ChatFormInput
                onSubmit={handleFreeQuestion}
                toggleFocusOn={inputDisabled}
                type="text"
                label="Posez votre question"
                value={messageValue}
                onChange={handleChange}
                valueToActive={messageValue}
                disabled={inputDisabled ? "disabled" : ""}
                required={true}
            >
                <SendButton disabled={inputDisabled || !messageValue ? "disabled" : ""}/>
            </ChatFormInput>
        </ContainerReponse>

    );
};

HandleFreeQuestion.propTypes = {
    responseBotDelay: PropTypes.number,
    setStep: PropTypes.func,
    handleChange: PropTypes.func,
    messageValue: PropTypes.string,
    inputDisabled: PropTypes.bool,
    addMessage: PropTypes.func,
    addBotMessage: PropTypes.func,
    setInputDisable: PropTypes.func,
    setUserInfos: PropTypes.func,
    loadingBotMessage: PropTypes.func,
    disableDatePicker: PropTypes.func,
    createFreeQuestion: PropTypes.func,
};

export default HandleFreeQuestion;
